import MultiStepForm from '@/components/forms/MultiStepForm';
import TokenInfo from '@/components/forms/apps/pma/TokenInfo';
import tenant from '@/services/TenantService';
import { toast } from 'react-toastify';
import ToastMessage from '@/components/toasts/ToastMessage';

export default function PMASetup({ deployment, app, onFinish, onCancel }) {
  const depl = deployment || {};
  const steps = [<TokenInfo key="tokenInfo" app={app} />];

  const handleSubmit = async (formData) => {
    const deploymentData = {
      app: app._id,
      config: formData,
    };

    try {
      const roleResponse = await tenant.post('/role', {
        name: 'PMA Backend Role',
        description: 'PMA Backend Role',
        permissions: {
          ups: {
            read: true,
            create: true,
            update: true,
            delete: true,
          },
          asset: {
            read: true,
            create: true,
            update: true,
            delete: true,
          },
          host: {
            read: true,
            create: true,
            update: true,
            delete: true,
          },
          vm: {
            read: true,
            create: true,
            update: true,
            delete: true,
          },
          deployment: {
            read: true,
            update: true,
          },
          interface: {
            read: true,
          },
          webhook: {
            create: true,
          },
        },
      });

      if (!roleResponse.status === 201) {
        toast.error(
          <ToastMessage
            title="Fehler"
            subtitle={
              roleResponse?.response?.data?.message ||
              'Fehler beim Erstellen der Konfiguration'
            }
          />,
        );
        return;
      }
      const roleId = roleResponse.data.insertedId;

      const deploymentResponse = await tenant.put(
        `/deployment/${depl.insertedId}`,
        deploymentData,
      );
      const { deployment } = deploymentResponse.data;

      const tokenResponse = await tenant.post('/token', {
        title: 'PMA Backend Token',
        description: 'PMA Backend Token',
        scope: [
          'asset.all',
          'interface.read',
          'interface.use',
          'deployment.read',
          'deployment.update',
          'webhook.create',
          'endpoint.all',
          'vm.all',
          'host.all',
          'ups.all',
          'room.all',
          'rack.all',
        ],
        roleId: roleId,
        deploymentId: depl?.insertedId,
      });

      if (!tokenResponse.status === 201) {
        toast.error(
          <ToastMessage
            title="Fehler"
            subtitle={
              tokenResponse?.response?.data?.message ||
              'Fehler beim Erstellen der Konfiguration'
            }
          />,
        );
        return;
      }

      onFinish(deployment, tokenResponse.data.token);
    } catch (error) {
      toast.error(
        <ToastMessage
          title="Fehler"
          subtitle={
            error?.response?.data?.message ||
            'Fehler beim Erstellen der Konfiguration'
          }
        />,
      );
    }
  };

  return (
    <MultiStepForm steps={steps} onSubmit={handleSubmit} onCancel={onCancel} />
  );
}
